import React from "react";
import { motion } from "framer-motion";
import ProgressBar from "./ProgressBar";

const pageTransitionVariants = {
  hidden: {
    x: "100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      // delay: 0.2,
      duration: 0.6,

      when: "beforeChildren",
      staggerChildren: 0.4,
    },
  },
  exit: {
    x: "-100vw",
  },
};
const Skills = () => {
  return (
    <motion.div
      variants={pageTransitionVariants}
      initial="hidden"
      animate="visible"
      className=" px-2 pb-16 sm:px-8"
    >
      <div className=" my-4 text-center font-primary text-gray-500 dark:text-lightText md:my-12">
        <p
          className=" mt-10 tracking-widest text-designColor
         opacity-95"
        >
          Features
        </p>
        <h2 className=" mb-12 text-2xl font-bold capitalize sm:text-4xl">
          Development skills
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-x-16 gap-y-8 md:grid-cols-2">
        <ProgressBar title={"html5"} percentage={"100%"} />
        <ProgressBar title={"css3"} percentage={"100%"} />
        <ProgressBar title={"Tailwind css"} percentage={"100%"} />
        <ProgressBar title={"Javascript"} percentage={"100%"} />
        <ProgressBar title={"React js"} percentage={"95%"} />
        <ProgressBar title={"Vite js"} percentage={"100%"} />
        <ProgressBar title={"Next js"} percentage={"98%"} />
        <ProgressBar title={"Node js"} percentage={"90%"} />
        <ProgressBar title={"Express js"} percentage={"90%"} />
        <ProgressBar title={"Mongo db"} percentage={"90%"} />
        <ProgressBar title={"Firebase"} percentage={"95%"} />
        <ProgressBar title={"wordpress"} percentage={"99%"} />
        <ProgressBar title={"Supabase"} percentage={"85%"} />
        <ProgressBar title={"web design"} percentage={"98%"} />
      </div>
    </motion.div>
  );
};

export default Skills;
